export const ANNOUNCEMENTS_TEMPLATES = [
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "background",
      layoutStructure: ["link", "arrow", "date"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "New office opening party!",
      text: "Minim irure anim labore laboris quis. Deserunt irure duis voluptate incididunt. Aliquip velit esse proident elit in.",
      linkText: "Details",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Zagreb, Croatia",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1605185992518-3838dfe13843?q=80&w=400&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "background",
      layoutStructure: ["link", "arrow", "date"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Product Launch Event: See What’s New!",
      text: "Minim irure anim labore laboris quis. Deserunt irure duis voluptate incididunt. Aliquip velit esse proident elit in.",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Zagreb, Croatia",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1735755642421-2694d8bb8c07?q=80&w=400&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "background",
      layoutStructure: ["link", "arrow", "date"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Monthly social: Drinks & Trivia Night!",
      text: "Minim irure anim labore laboris quis. Deserunt irure duis voluptate incididunt. Aliquip velit esse proident elit in.",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Zagreb, Croatia",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1608048608029-99c772d199ed?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "classic",
      layoutStructure: ["text", "date", "location", "time", "participants"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "All-Hands: Let’s Align for Q2",
      text: "Review Q1 highlights, key Q2 priorities, and an open Q&A with leadership.",
      linkText: "Read more",
      url: {},
      time: "10:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Main conference room / Zoom",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1736092306725-f0485a49367e?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "classic",
      layoutStructure: ["text", "date", "location", "time", "participants"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Be the first to experience our latest product!",
      text: "Join us for a live demo and Q&A with the product team.",
      linkText: "Read more",
      url: {},
      time: "14:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Event Hall B",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1736092306725-f0485a49367e?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "notification",
      layoutStructure: ["text", "date", "icon", "link", "arrow"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Give back with your team!",
      text: "Join us for a company-wide Volunteer Day. Pick from several local initiatives and spend the day giving back to the community. It’s a great way to make a difference and bond with your teammates.",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Central Europe",
      newTab: "true",
      emoji: {
        id: "handshake",
        name: "Handshake",
        short_names: ["handshake"],
        colons: ":handshake:",
        emoticons: [],
        unified: "1f91d",
        skin: null,
        native: "🤝",
      },
      emojiEnabled: true,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1736092306725-f0485a49367e?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "notification",
      layoutStructure: ["text", "date", "icon", "link", "arrow"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "We're expanding!",
      text: "Join us for drinks, snacks, and a first look at our brand-new office!",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Central Europe",
      newTab: "true",
      emoji: {
        id: "tada",
        name: "Party Popper",
        short_names: ["tada"],
        colons: ":tada:",
        emoticons: [],
        unified: "1f389",
        skin: null,
        native: "🎉",
      },
      emojiEnabled: true,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1736092306725-f0485a49367e?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "image",
      layoutStructure: ["date", "location", "participants"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Wellness Week: Activities & Workshops",
      text: "Join us for drinks, snacks, and a first look at our brand-new office!",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "123 New Street, Downtown",
      newTab: "true",
      emoji: {
        id: "tada",
        name: "Party Popper",
        short_names: ["tada"],
        colons: ":tada:",
        emoticons: [],
        unified: "1f389",
        skin: null,
        native: "🎉",
      },
      emojiEnabled: true,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1444312645910-ffa973656eba?q=80&w=3456&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "image",
      layoutStructure: ["date", "location", "participants"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Hackathon Kickoff: Innovate & Build",
      text: "Join us for drinks, snacks, and a first look at our brand-new office!",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Innovation lab",
      newTab: "true",
      emoji: {
        id: "tada",
        name: "Party Popper",
        short_names: ["tada"],
        colons: ":tada:",
        emoticons: [],
        unified: "1f389",
        skin: null,
        native: "🎉",
      },
      emojiEnabled: true,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1622737133809-d95047b9e673?q=80&w=3432&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
];

export const OVERVIEW_ANNOUNCEMENTS_TEMPLATES = [
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "classic",
      layoutStructure: ["text", "date", "location", "time", "participants"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "All-Hands: Let’s Align for Q2",
      text: "Review Q1 highlights, key Q2 priorities, and an open Q&A with leadership.",
      linkText: "Read more",
      url: {},
      time: "10:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Main conference room / Zoom",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1736092306725-f0485a49367e?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "background",
      layoutStructure: ["link", "arrow", "date"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "New office opening party!",
      text: "Minim irure anim labore laboris quis. Deserunt irure duis voluptate incididunt. Aliquip velit esse proident elit in.",
      linkText: "Details",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Zagreb, Croatia",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1605185992518-3838dfe13843?q=80&w=400&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "background",
      layoutStructure: ["link", "arrow", "date"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "Product Launch Event: See What’s New!",
      text: "Minim irure anim labore laboris quis. Deserunt irure duis voluptate incididunt. Aliquip velit esse proident elit in.",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Zagreb, Croatia",
      newTab: "true",
      emoji: {
        id: "smile",
        name: "Smiling Face with Open Mouth and Smiling Eyes",
        short_names: ["smile"],
        colons: ":smile:",
        emoticons: ["C:", "c:", ":D", ":-D"],
        unified: "1f604",
        skin: null,
        native: "😄",
      },
      emojiEnabled: false,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1513956860062-4983f30a954d?q=80&w=1536&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
  {
    config: {
      view: "card",
      columns: 2,
      designStyle: "notification",
      layoutStructure: ["text", "date", "icon", "link", "arrow"],
      displayNumberOfItems: 4,
      dateFormat: "HH:mm",
      borderRadius: 13,
    },
    announcement: {
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
      icon: "bootstrap/CloudsFill",
      title: "We're expanding!",
      text: "Join us for drinks, snacks, and a first look at our brand-new office!",
      linkText: "Read more",
      url: {},
      time: "18:00",
      color: { light: "#003BFF", dark: "#003BFF" },
      textColor: { light: "#ffffff", dark: "#ffffff" },
      location: "Central Europe",
      newTab: "true",
      emoji: {
        id: "tada",
        name: "Party Popper",
        short_names: ["tada"],
        colons: ":tada:",
        emoticons: [],
        unified: "1f389",
        skin: null,
        native: "🎉",
      },
      emojiEnabled: true,
      image: {
        id: crypto.randomUUID(),
        link: "https://images.unsplash.com/photo-1736092306725-f0485a49367e?q=80&w=500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        source: "unsplash",
      },
    },
  },
];

export const getAnnouncementsTemplates = ({
  cornerRadius,
  selectedColors,
  isInOverview = false,
}) =>
  (isInOverview
    ? OVERVIEW_ANNOUNCEMENTS_TEMPLATES
    : ANNOUNCEMENTS_TEMPLATES
  ).map((template) => ({
    ...template,
    config: {
      ...template.config,
      borderRadius: cornerRadius || 13,
    },
    announcement: {
      ...template.announcement,
      color: {
        light: selectedColors?.light[0]?.accent || "#003BFF",
        dark: selectedColors?.dark[0]?.accent || "#003BFF",
      },
      textColor: {
        light: selectedColors?.light[0]?.text || "#ffffff",
        dark: selectedColors?.dark[0]?.text || "#ffffff",
      },
    },
  }));
